const getOwnerBrokerType = (salesChannel, brokerType) => {
  if (['jtc-b2b', 'flysure-b2b', 'jtc-brokers'].includes(salesChannel)) {
    return 'OwnerAsBroker';
  }
  if (brokerType === 'broker') {
    return 'OwnerAsBroker';
  }

  return 'Owner';
};

export default getOwnerBrokerType;
